
.reviewInfo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: auto;
  margin-bottom: 0.5rem;
  padding-top: 1%;
  padding-bottom: 1%;
  background-color: #DCEDFB;
  border-radius: 8px;
  width: 100%;
  color: #666;
  font-size: 13px;
  margin-left: 0px !important;
}

.reviewInfo div {
  margin-left: 1.5rem;
  margin-right: 0.5rem;
}

.errorMessage {
  display: flex;
  justify-content: flex-end;
}

.errorMessage p {
  margin-bottom: 0px;
}
